export const SystemControllerIssueTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems list</span>.
            </li>
            <li>
                <span className="font-semibold">Go</span> to the <span className="font-semibold">Events Tab</span>.
            </li>
            <li>
                <span className="font-semibold">Look into</span> issues related to system controllers
                by <span className="font-semibold">selecting</span> the <span className="font-semibold">event
                    name</span>.
            </li>
            <li>
                <span className="font-semibold">Apply</span> the recommended actions provided by Enphase.
            </li>
        </ul>
    </div>
